/**
 * AI 审核管理后台 API 封装
 * 对应后端: signnew - com.lifeos.aiaudit
 */
import service from '@/request/request.js';

// ============ 规则主表 ============
export const aiRuleApi = {
  page(params) {
    return service.get('/api/admin/ai-rule/page', { params });
  },
  getById(id) {
    return service.get(`/api/admin/ai-rule/${id}`);
  },
  create(data) {
    return service.post('/api/admin/ai-rule', data);
  },
  update(id, data) {
    return service.put(`/api/admin/ai-rule/${id}`, data);
  },
  remove(id) {
    return service.delete(`/api/admin/ai-rule/${id}`);
  },
  toggle(id, enabled) {
    return service.put(`/api/admin/ai-rule/${id}/enable`, { enabled });
  }
};

// ============ 检查项 ============
export const aiCheckItemApi = {
  page(params) {
    return service.get('/api/admin/ai-check-item/page', { params });
  },
  listByRule(ruleId) {
    return service.get(`/api/admin/ai-check-item/by-rule/${ruleId}`);
  },
  getById(id) {
    return service.get(`/api/admin/ai-check-item/${id}`);
  },
  create(data) {
    return service.post('/api/admin/ai-check-item', data);
  },
  update(id, data) {
    return service.put(`/api/admin/ai-check-item/${id}`, data);
  },
  remove(id) {
    return service.delete(`/api/admin/ai-check-item/${id}`);
  },
  toggle(id, enabled) {
    return service.put(`/api/admin/ai-check-item/${id}/enable`, { enabled });
  },
  batchToggle(ids, enabled) {
    return service.put('/api/admin/ai-check-item/batch-enable', { ids, enabled });
  },
  duplicate(id) {
    return service.post(`/api/admin/ai-check-item/${id}/duplicate`);
  },
  previewPrompt(sceneCode, feeTypes) {
    // feeTypes: 数组,需要展开成多个同名参数
    const params = new URLSearchParams();
    params.append('sceneCode', sceneCode);
    if (feeTypes && feeTypes.length) {
      feeTypes.forEach(ft => params.append('feeTypes', ft));
    }
    return service.get('/api/admin/ai-check-item/preview-prompt?' + params.toString());
  }
};

// ============ 大模型配置 ============
export const aiLlmApi = {
  list() {
    return service.get('/api/admin/ai-llm/list');
  },
  create(data) {
    return service.post('/api/admin/ai-llm', data);
  },
  update(id, data) {
    return service.put(`/api/admin/ai-llm/${id}`, data);
  },
  remove(id) {
    return service.delete(`/api/admin/ai-llm/${id}`);
  },
  setDefault(id) {
    return service.put(`/api/admin/ai-llm/${id}/set-default`);
  },
  test(id) {
    return service.post(`/api/admin/ai-llm/${id}/test`);
  }
};

// ============ 审核任务 ============
export const aiAuditApi = {
  submit(data) {
    return service.post('/api/ai-audit/submit', data);
  },
  pageTasks(params) {
    return service.get('/api/ai-audit/task/page', { params });
  },
  getTask(taskId) {
    return service.get(`/api/ai-audit/task/${taskId}`);
  },
  getReport(taskId) {
    return service.get(`/api/ai-audit/report/${taskId}`);
  },
  getFailedReport(taskId) {
    return service.get(`/api/ai-audit/report/${taskId}/failed`);
  }
};

// ============ 字典(费用类型/文档类型等下拉选项) ============
export const aiDictApi = {
  /** 业务侧拉启用项(下拉框用) */
  options(dictType) {
    return service.get('/api/ai-dict/options', { params: { dictType } });
  },
  /** 后台列表(含禁用) */
  list(dictType) {
    return service.get('/api/admin/ai-dict/list', { params: dictType ? { dictType } : {} });
  },
  create(data) {
    return service.post('/api/admin/ai-dict', data);
  },
  update(id, data) {
    return service.put(`/api/admin/ai-dict/${id}`, data);
  },
  remove(id) {
    return service.delete(`/api/admin/ai-dict/${id}`);
  },
  toggle(id, enabled) {
    return service.put(`/api/admin/ai-dict/${id}/enable`, { enabled });
  }
};

// ============ 规则导入 ============
export const aiImportApi = {
  importDefault() {
    return service.post('/api/admin/ai-rule-import/default');
  },
  importPath(path) {
    return service.post(`/api/admin/ai-rule-import/path?path=${encodeURIComponent(path)}`);
  }
};
